import {
  checkLotSuffixActionType,
  checkLotSuffixSuccessActionType,
  checkLotSuffixFailureActionType,
} from 'actions/Locations/checkLotSuffix';

const INITIAL_STATE = {
  isPending: false,
  result: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case checkLotSuffixActionType:
      return {
        isPending: true,
        result: null,
      };
    case checkLotSuffixSuccessActionType:
      return {
        isPending: false,
        result: action.payload.result.data,
      };
    case checkLotSuffixFailureActionType:
      return { ...INITIAL_STATE };
    default:
      return state;
  }
};
